// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".answer-text[data-v-ea7de156]{color:var(--quiz-text-color);margin:25px 0}.answer-list[data-v-ea7de156]{margin:10px 0;padding:0 30px 16px 30px}.correct[data-v-ea7de156]{color:var(--quiz-correct-color)}.incorrect[data-v-ea7de156]{color:var(--quiz-incorrect-color)}.explanation[data-v-ea7de156]{color:var(--quiz-text-color);margin:25px 0}hr[data-v-ea7de156]{margin-bottom:25px}", ""]);
// Exports
module.exports = exports;
